import { Component, ChangeDetectionStrategy, InputSignal, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { DurationPipe } from '../../../pipes/duration.pipe';
import { Lesson } from '../../../domain/learn/learn.domain';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { IconComponent } from '../../../components/icon/icon.component';
import { DatePipe } from '../../../pipes/date.pipe';

@Component({
  selector: 'td-wb-learn-lesson-info',
  templateUrl: 'learn-lesson-info.component.html',
  styleUrls: ['learn-lesson-info.component.scss'],
  imports: [
    IconComponent,
    DatePipe,
    DurationPipe,
    TranslatePipe,
    TranslateDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LearnLessonInfoComponent {
  readonly lesson: InputSignal<Lesson> = input<Lesson>();
  readonly hideFilters: InputSignal<boolean> = input<boolean>(false);

  showFilters(): boolean {
    return this.hideFilters() === false && this.lesson()?.filters?.length > 0;
  }
}

